<template>
  <v-row class="text-left full-height">
    <v-col cols="12">
      <v-card flat class="my-2 ml-3 mr-2">
        <v-row>
          <v-col cols="12" class="px-0">
            <v-form v-model="form.validReportingInfo" onSubmit="return false;" class="full-width">
              <v-card-title>Reporting Options</v-card-title>
              <v-card-text
                >You can customize the columns that appear in the reporting dashboard.
              </v-card-text>
              <v-card-text>
                <strong>Note:</strong> Any changes could take up to an hour to reflect in your
                reports.
              </v-card-text>
              <v-card-text>
                <v-row class="full-width px-4 mt-3">
                  <v-col cols="12" sm="12" md="6" class="px-0 pt-0">
                    <v-select
                      v-model="reportColumn1"
                      :items="customReportColumns"
                      label="Report Column 1"
                      item-value="value"
                      item-text="label"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      v-model="reportColumn2"
                      :items="customReportColumns"
                      label="Report Column 2"
                      item-value="value"
                      item-text="label"
                      class="mt-4"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      v-model="reportColumn3"
                      :items="customReportColumns"
                      label="Report Column 3"
                      item-value="value"
                      item-text="label"
                      class="mt-4"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      v-model="reportColumn4"
                      :items="customReportColumns"
                      label="Report Column 4"
                      item-value="value"
                      item-text="label"
                      class="mt-4"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </v-col>
        </v-row>
        <div class="d-flex justify-center flex-column align-center">
          <v-btn
            @click="handleSave"
            :disabled="!form.validReportingInfo"
            :loading="loading.general"
            depressed
            rounded
            color="brandCyan"
            class="white--text my-4"
            >Save Changes</v-btn
          >
          <p v-if="error.general" class="error--text">
            {{ error.general }}
          </p>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClientService from "@/services/ClientServiceV2";

import { formRules, userColumns } from "@/shared_data/data";

import { mapState } from "vuex";

function initialState() {
  return {
    clientService: new ClientService(),

    // Client info
    reportColumn1: null,
    reportColumn2: null,
    reportColumn3: null,
    reportColumn4: null,

    // Static
    formRules,
    customReportColumns: userColumns,

    // Dialogs, API, and forms
    dialog: {},
    form: {
      validReportingInfo: true,
    },
    error: {
      general: null,
    },
    loading: {
      general: false,
    },
  };
}
export default {
  name: "ClientReportingManager",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      required: false,
    },
  },
  components: {},
  data() {
    return initialState();
  },
  created() {
    this.loadClient();
  },
  beforeUnmount() {},
  methods: {
    resetPage() {
      Object.assign(this.$data, initialState());
    },
    loadClient() {
      this.resetPage();

      if (!this.client) {
        console.error("Client not found", this.globalClientId);
        return;
      }
      console.log("Loading client", this.client);

      const { clientId, reportColumn1, reportColumn2, reportColumn3, reportColumn4 } = this.client;

      this.clientId = clientId;
      this.reportColumn1 = reportColumn1;
      this.reportColumn2 = reportColumn2;
      this.reportColumn3 = reportColumn3;
      this.reportColumn4 = reportColumn4;
    },
    async handleSave() {
      if (!this.form.validReportingInfo) return;

      try {
        this.loading.general = true;
        this.error.general = null;

        let body = {
          reportColumn1: this.reportColumn1,
          reportColumn2: this.reportColumn2,
          reportColumn3: this.reportColumn3,
          reportColumn4: this.reportColumn4,
        };

        await this.clientService.updateClientV3(this.clientId, body);

        console.log("reporting options saved", this.clientId);
        await this.$emit("getClient", { clientId: this.clientId });
      } catch (e) {
        this.error.general = e.message || "Failed to save options";
      } finally {
        this.loading.general = false;
      }
    },

    resetState() {
      this.reportColumn1 = null;
      this.reportColumn2 = null;
      this.reportColumn3 = null;
      this.reportColumn4 = null;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients", "globalClientId"]),
  },
  watch: {
    client: {
      handler() {
        console.log("client changed", this.client);
        this.loadClient();
      },
    },
  },
};
</script>

<style scoped></style>
